module.exports = __webpack_public_path__ + "static/media/81sqCTTNquL._SL1500_.9cfdec2f.jpg";